import styled from 'styled-components';

export const TopBar = styled.header`
  display: flex;
  width: 100%;
  height: 47px;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background-color: #0f1117;
  color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 10;

  .logo {
    height: 31px;
    width: auto;
    display: block;
  }

  .logo-link {
    display: flex;
    align-items: flex-end;
    flex-shrink: 0;
  }
`;

export const BreadcrumbGroup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-left: 24px;
  flex: 1;
  min-width: 0;
`;

export const Separator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 31px;
  color: #4a5060;
  user-select: none;
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
`;

export const Chip = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 31px;
  padding: 0 10px;
  border-radius: 6px;
  border: none;
  background: ${({ $active }) => ($active ? '#1f2330' : 'transparent')};
  /* Dropdown text + icon color (company / project / period breadcrumb chips). */
  color: #909296;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
  max-width: 280px;
  line-height: 1;

  &:hover {
    background: #1f2330;
  }

  span.label {
    color: #909296;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Any nested icon. react-icons SVGs render with fill=currentColor, so
     setting color cascades to the rendered glyph. */
  svg {
    color: #909296;
    flex-shrink: 0;
  }
`;

export const RightSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
`;

// Profile is shared with the white legacy Sidebar; these overrides re-style
// only the AppTopBar instance (typography spec from the new design system).
export const ProfileSlot = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  .name {
    color: #f1f3f5 !important;
    text-align: right;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
  }
  .email {
    color: #868e96 !important;
    text-align: right;
    font-family: Roboto, sans-serif;
    font-size: 10px;
    font-weight: 400;
    line-height: 140%;
  }
  /* Hover bg from Profile is light blue — keep dark-friendly */
  button:hover {
    background-color: #1f2330 !important;
  }
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #1f2330;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
